<template>
    <div class="mask">
        <div class="paymentIndex">
            <div class="cross">
                <div>{{OrderDetail.hotel_title}}</div>
                <!-- <van-icon name="cross"  size="22px" @click="$emit('payment')" /> -->
            </div>
            <div class="totalPrice">
                <span>¥</span>
                <h1>{{flag==1?PaymentDeposit():PaymentTail()}}</h1>
            </div>
            <span class="flagtext">待支付</span>
            <span class="flagtext" v-if="OrderDetail.price_pay!=0">（已支付{{OrderDetail.price_pay/100}}元）</span>
                <ul class="way">
                    <li 
                        v-if="OrderDetail.deposit!=0" 
                        :class="flag==1?'active':OrderDetail.price_pay>=OrderDetail.deposit?'deposit':'inactive'" 
                        @click="deposit(1)">
                        <p>支付订金</p><div class="payment-money"><span>{{PaymentDeposit()}}</span></div>
                    </li>
                    <li :class="flag==2?'active':'inactive'" @click="deposit(2)"><p>{{OrderDetail.price_pay<=OrderDetail.deposit?'支付总额':'支付尾款'}}</p><div class="payment-money"><span>{{PaymentTail()}}元</span></div></li>
                    <li  @click="tabvalue=!tabvalue" :class="{'payment-way':tabvalue}">
                            <p>支付方式</p>
                            <div class="payment-select">
                                <img :src="paymentMethod[value].src">
                                <span>{{paymentMethod[value].name}}</span>
                                <i :class="tabvalue?'el-icon-arrow-up':'el-icon-arrow-down'" class="arrow-down"></i>
                            </div>
                            <div class="payment-select-list" v-if="tabvalue" >
                                <div v-for="(item,index) in paymentMethod" :key="item.value" @click.stop="tabSelect(index)">
                                    <img :src="item.src">
                                    <p>{{item.name}}</p>
                                </div>
                            </div>
                    </li>
                </ul>

            <!-- <div class="payment-way">需支付：{{flag==1?PaymentDeposit():PaymentTail()}}</div> -->
            <!-- <div type="success"  @click="payment" class="payment-Gopay">确认支付</div> -->
        </div>
        <div class="qrCode">
            <div class="qrCode-img">
                <div class="qrCode-loading" v-if="value==0&&qrCodeUrl!=''">
                    <img :src="qrCodeUrl" alt="QR Code">
                    <img src="/images/logo/wx_1.png" class="wx-logo">
                </div>
                <iframe :srcdoc="qianHtml"
                        v-if="value==1"
                        frameborder="no"
                        border="0"
                        marginwidth="0"
                        marginheight="0"
                        scrolling="no"
                        width="120"
                        height="120"
                        style="overflow:hidden;margin-top: 18px;">
                </iframe>
            </div>
            <div class="qrCode-title" :class="{'qrCode-title-active':value==1}">
                <img src="/images/logo/xix.png" class="xix-logo" >
                <div class="qrCode-text">
                    <p>打开手机{{value==0?'一微信':'支付宝'}}</p>
                    <p>扫一扫继续付款</p>
                </div>
            </div>
            <!-- <div class="qrCode-bottom">
                <p>完成支付</p>
            </div> -->
        </div>
        <div class="aliform" v-html="aliform"></div>
    </div>
</template>

<script>
    import qrcode from 'qrcode';
    import {mapState} from 'vuex'
    export default {
        name: "payment",
        computed: {
            ...mapState(['newMessageInform']),
        },
        props:{
            logon:{ default: true },
            OrderDetail:{
                type:Object,
                default: {}
            },
        },
        data() {
            return {
                aliform: "",
                flag:'1',                       //支付方式1订金2全额尾款
                oid:0,                          //订单号
                qianHtml:'',                    //二维码内容
                paymentMethod:[
                    {name:'微信',value:'1',src:'/images/logo/wx.png'},
                    {name:'支付宝',value:'2',src:'/images/logo/zfb.png'},
                ],
                tabvalue:false,
                value:0,
                qrCodeUrl:'',                    //展示二维码
                codeUrl: '',                    // 这里替换为解析二维码路径
            }
        },
        mounted() {
            //如果没订金则默认选择全款
            if(this.OrderDetail.deposit==0||this.OrderDetail.deposit!=0&&this.OrderDetail.deposit<=this.OrderDetail.price_pay){
                this.flag='2' 
            }else{
                this.flag='1'
            }
            this.payment();
        },

        // components: {CardInfoComponent},
        methods: {
            //解析二维码
            async generateQRCode() {
            try {
                const url = this.codeUrl;
                const response = await qrcode.toDataURL(url);
                this.qrCodeUrl = response;
                } catch (err) {
                console.error(err);
                }
            },
            //切换支付金额
            deposit(e){
                console.log(this.OrderDetail.deposit,this.OrderDetail.price_pay,this.flag)
                if( this.OrderDetail.deposit>this.OrderDetail.price_pay&&this.flag=='2'&&e==1){
                    this.flag='1';
                    this.payment(); 
                };
                if(this.flag=="1"&&e==2){
                    this.flag='2';
                    this.payment();
                }
            },
            //计算还需支付订金
            PaymentDeposit(){
                let OrderDetail=this.OrderDetail; //订单详情
                let deposit = OrderDetail.deposit*100; //订金总额
                let price_pay = OrderDetail.price_pay; //已支付含订金
                deposit = (deposit - price_pay)/100; //剩余支付 
                return deposit<=0?'已支付':deposit+'元';
            },
            //计算支付尾款
            PaymentTail(){
                let OrderDetail=this.OrderDetail; //订单详情
                let price = OrderDetail.price*100; //订单总额
                let price_pay = OrderDetail.price_pay; //已支付含订金
                price = (price - price_pay)/100; //剩余支付
                return price;
            },
            //切换支付方式
            tabSelect(index){
                this.value=index;
                this.tabvalue=false;
                this.payment();
            },
            //点击支付
            payment(){
                let data = {oid:this.OrderDetail.oid,pay_flag:this.flag,pay_type:3};
                this.$emit('payment');
                //微信支付
                if(this.value==0){this.paymentNative(data)}
                //支付宝支付
                if(this.value==1){this.alipayH5(data)}
            },
            //微信二维码支付
            async paymentNative(data){
                let resData = await this.$axios.post('/pc/WeChatPay/Native',data);
                if(resData.code=="00000"){
                    this.codeUrl = resData.data.code_url;
                    this.generateQRCode();
                }
            },
            //支付宝二维码支付
            async alipayH5(data){
                let resData = await this.$axios.post('/pc/AliPay/Native',data);
                if(resData.code=="00000"){
                    this.qianHtml=resData.data;
                }

            },
        }
    }
</script>
<style scoped>
.qrCode-img{
    overflow: hidden;
    margin-top: 40px;
    height: 148px;
}
.paymentIndex{
    width: 400px ;
    bottom: 0;
    left: 0;
    height: 100%;
    border-radius: 16px 16px 0 0;
    float: left;
    padding-bottom: 60px;
    position: relative;
    z-index: 9;
}
.payment-Gopay{
    margin: 20px auto;
    margin-top: 50px;
    width: 80%;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    font-size: 14px;
    letter-spacing: 2px;
    background-color: #17c967;
    color: #fff;
    text-align: center;
    cursor: pointer;
}
.cross{
    display: flex;
    justify-content: right;
    overflow: hidden;
    width: 80%;
    margin: 0 auto;

    padding: 12px 10%;

    /* color: #fff; */
    font-weight: bold;
    letter-spacing: 1px;
}
.cross div{
    margin: 0 auto;
}
.totalPrice{
    display: flex;
    justify-content:center;
    margin-top: 10px;
}
.totalPrice span{
    margin-top:11px;
    font-weight: bold;
}
.totalPrice h1{
    padding: 0 2px;
}
.oid{
    text-align: center;
    padding: 20px 0;
    font-size: 14px;
}
.payment{
    width: 88%;
    background-color: #fff;
    padding: 2%;
    margin: 20px auto;
    border-radius: 4px;
}
.payment p{
    line-height: 30px;
    border-bottom: 1px #eee solid;
    text-align: left;
    font-size: 12px;
    color: #666;
}
.flagtext{
    display: block;
    color: #999;
    font-size: 12px;
    text-align: center;
}
.way{
    width: 100%;
    margin: 0 auto;
}
.way li{
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    border: 1px #eee solid;
    border-radius: 25px;
    width: 70%;
    padding: 0 6%;
    margin: 0 auto;
    margin-top: 12px;
    position: relative;
    cursor: pointer;
    
}
.way li .payment-money{
    display: flex;
    width: 40%;
    justify-content: right;
}
.way li .payment-money span{
   margin-right: 6px;
}
.payment-select{
    line-height: 40px;
    overflow: hidden;
}
.payment-select img{
    width: 20px;
    height: 20px;
    margin-top: 9px;
    float: left;
    margin-right: 4px;
}
.payment-select span{
    margin-right: 1px;
}
.arrow-down{
    font-size: 12px;
}
.way .active{
    border: 1px #17c967 solid;
}
.deposit{
    background-color: #eee;
    color: #999;
}
.way .payment-way{
    position: relative;
    border-radius: 25px 25px 0 0;
}
.way .payment-select-list{
    position: absolute;
    top: 40px;
    left: -1px;
    width: 100.2%;
    display: flex;
    justify-content: space-between;
    border: 1px #eee solid;
    background-color: #fff;
    border-top: 1px #f5f5f5 solid;
    border-radius: 0 0 10px 010px;

}
.payment-select-list div{
    width: 50%;
    display: flex;
    justify-content: center;
    line-height: 36px;
    border-right: 1px #f5f5f5 solid;

}
.payment-select-list div:nth-child(2){
    border-right: none;
}
.payment-select-list div img{
    width: 14px;
    height: 14px;
    margin-top: 11px;
    margin-right: 4px;
}
.qrCode{
    width: 200px;
    float: right;
    text-align: center;
    border-left: 1px solid transparent;
    background: linear-gradient(white,white) padding-box,
    repeating-linear-gradient(-45deg,#ccc 0, #ccc 0.5em,white 0,white 0.75em);
    position: absolute;
    top: 0;
    right: 0;
    height: 300px;
}
.mask{
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-top:15px
}
.qrCode-loading{
    position: relative;
   
}
.wx-logo{
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}


.qrCode-title{
    width: 58%;
    margin: 0 auto;
}
.qrCode-title-active{
    margin-top: 8px;
}
.qrCode-text{
    float: right;
    text-align: center;
    font-size: 11px;
    margin-left: 10px;
    margin-top: -2px;
}
.xix-logo{
    float: left;
    width:28px;
}
</style>
<style>

    .van-popup__close-icon--top-right{
        top: 11px;
        color: #fff;
        right: 12px;
    }
</style>